import { render, staticRenderFns } from "./DHSchemaNode.vue?vue&type=template&id=1b108268&scoped=true"
import script from "./DHSchemaNode.vue?vue&type=script&lang=js"
export * from "./DHSchemaNode.vue?vue&type=script&lang=js"
import style0 from "./DHSchemaNode.vue?vue&type=style&index=0&id=1b108268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b108268",
  null
  
)

export default component.exports